import { useEffect, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

export function useRegistrySyncUser() {
  const location = useLocation();
  const history = useHistory();

  const hasTriggered = useRef(false);

  const syncFromRegistry = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('from') === 'registry';
  }, [location.search]);

  const queryClient = useQueryClient();

  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['registry-sync-user'],
    mutationFn: () => apiServiceProxy.post('/registry/sync-user', {}).then(response => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['registry-check'] });
    }
  });

  useEffect(() => {
    if (!syncFromRegistry || hasTriggered.current) {
      return;
    }

    hasTriggered.current = true;

    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('from');
    history.replace({ ...location, search: searchParams.toString() });

    mutate();
  }, [history, location, mutate, syncFromRegistry]);

  return { isSyncing: isPending, isError };
}
